module.exports = __webpack_public_path__ + "img/play_video_replace.03154122.png";